export function clearStorage() {
    var backofficeLanguage = localStorage.getItem("backofficeLanguage")
    localStorage.clear();
    if (backofficeLanguage) {
        localStorage.setItem("backofficeLanguage", backofficeLanguage);
    }
}
